<!-- <ng-container *ngIf="filteredInpatients.length > 0; else noInpatients">
    <ng-container *ngFor="let hospital of inpatientHospitals">
        <div class="list-header expandable" (click)="toggleHospitalList(hospital.id)">
            {{ hospital.name }}
            <mat-icon aria-hidden="false" aria-label="Example home icon">
                {{ expandedHospitalId === hospital.id ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <mat-list @expandCollapse *ngIf="expandedHospitalId === hospital.id">
            <app-patient-list-item *ngFor="let patient of filteredInpatientsByHospital[hospital.id]" [patient]="patient"
                [isInpatient]="true"></app-patient-list-item>
        </mat-list>
    </ng-container>
</ng-container>



<ng-template #noInpatients>
    <p class="no-records-message">No patients found.</p>
</ng-template> -->

<!--
    Gate on what is actually about to be rendered — `inpatientHospitals` — not on
    `filteredInpatients`. Those two can disagree, and when they did this template rendered
    NOTHING: patients existed so the *ngIf was true and the empty-state template never ran, while
    the *ngFor below had an empty list to iterate. A blank panel with no explanation, and no way
    for anyone looking at it to tell whether that meant "no patients" or "something broke".
    Every branch below now says something.
-->
<ng-container *ngIf="inpatientHospitals.length > 0; else nothingToShow">
    <ng-container *ngFor="let hospital of inpatientHospitals">
        <div class="list-header expandable" (click)="toggleHospitalList(hospital.id)">
            {{ hospital.name }}
            <mat-icon aria-hidden="false" aria-label="Expand/Collapse">
                {{ expandedHospitalId === hospital.id ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <div *ngIf="expandedHospitalId === hospital.id">
            <ng-container *ngFor="let ward of hospital.wards">
                <div class="list-header ward-header">
                    {{ ward.name }}
                </div>
                <mat-list>
                    <app-patient-list-item *ngFor="let patient of ward.patients" [patient]="patient"
                        [isInpatient]="true"></app-patient-list-item>
                </mat-list>
            </ng-container>
        </div>
    </ng-container>
</ng-container>
<div class="mobile-spacer"></div>

<ng-template #nothingToShow>
    <!-- No admitted patients at all, or none matching the search. The ordinary empty state. -->
    <p class="no-records-message" *ngIf="filteredInpatients.length === 0">No patients found.</p>

    <!--
        Patients ARE admitted, but not one of them could be grouped under a hospital this practice
        currently has — their `hospitalId` matches nothing in the hospital list. That is a data
        problem, not an empty list, and the two must not look alike: saying "No patients found"
        about patients who exist is worse than saying nothing.
    -->
    <p class="no-records-message" *ngIf="filteredInpatients.length > 0">
        {{ filteredInpatients.length }} admitted
        {{ filteredInpatients.length === 1 ? 'patient is' : 'patients are' }} on file, but
        {{ filteredInpatients.length === 1 ? 'their' : 'their' }} hospital is not on this
        practice's list, so {{ filteredInpatients.length === 1 ? 'it' : 'they' }} cannot be shown
        here. Check the hospital and ward settings for this practice.
    </p>
</ng-template>